/* eslint-disable prettier/prettier */
import React from "react";

const NightIcon = ({ onClickHandle }: any) => (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_2479_2)">
<rect x="4" y="4" width="16" height="16" rx="4" fill="#E4FFEC"/>
</g>
<path d="M12 7C9.243 7 7 9.243 7 12C7 14.757 9.243 17 12 17C14.757 17 17 14.757 17 12C17 9.243 14.757 7 12 7ZM12 16C9.7945 16 8 14.2055 8 12C8 9.7945 9.7945 8 12 8C14.2055 8 16 9.7945 16 12C16 14.2055 14.2055 16 12 16Z" fill="#59C376"/>
<path d="M12.5 9.5H11.5V12.207L13.1465 13.8535L13.8535 13.1465L12.5 11.793V9.5Z" fill="#59C376"/>
<defs>
<filter id="filter0_d_2479_2" x="0" y="0" width="24" height="24" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2479_2"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2479_2" result="shape"/>
</filter>
</defs>
</svg>

);

export default NightIcon;